export default "/fonts/bauhs93-webfont.woff2?978e7a56253ad6e21273970f16d5e09d";